import { render, staticRenderFns } from "./app-pay.vue?vue&type=template&id=a3bddf88&scoped=true"
import script from "./app-pay.vue?vue&type=script&lang=js"
export * from "./app-pay.vue?vue&type=script&lang=js"
import style0 from "./app-pay.vue?vue&type=style&index=0&id=a3bddf88&prod&lang=css"
import style1 from "./app-pay.vue?vue&type=style&index=1&id=a3bddf88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bddf88",
  null
  
)

export default component.exports